// extracted by mini-css-extract-plugin
export var about_section = "about-module--about_section--f0kse";
export var inner_section = "about-module--inner_section--1uegS";
export var about_tech = "about-module--about_tech--245b_";
export var me = "about-module--me--whisf";